import React from "react";
import { timeToast } from "../../../Constant";
import { toast } from "react-toastify";
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap";
import {
  APIDeleteSuccessMsg,
  getItemDeleteSuccessMsg,
} from "../../../Constant/Message";
import DATA_TYPE from "../../../Constant/DataType";
toast.configure();

const ConfirmRemovalModal = ({
  deleteModalOpen,
  toggleDeleteModal,
  selectedAkun,
  getRencImp,
  axiosInstance,
}) => {
  const deleteDaftarAkun = () => {
    axiosInstance.delete("rencanaimp/" + selectedAkun.pk).then(() => {
      console.log(APIDeleteSuccessMsg);
      toggleDeleteModal();
      toast.success(getItemDeleteSuccessMsg(DATA_TYPE.Akun), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
      getRencImp();
    });
  };

  return (
    <Modal isOpen={deleteModalOpen} toggle={() => toggleDeleteModal()}>
      <ModalHeader>Anda yakin ingin menghapus akun yang dipilih?</ModalHeader>

      <ModalFooter>
        <Button
          color="primary"
          type="button"
          onClick={() => toggleDeleteModal()}
        >
          Batal
        </Button>
        <Button type="button" color="danger" onClick={() => deleteDaftarAkun()}>
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmRemovalModal;
